export function formatDate(date: Date): string;
export function formatDate(date: Date | null | undefined): string | undefined;
export function formatDate(date: Date | null | undefined): string | undefined {
  if (!date) return undefined;
  return new Date(date).toLocaleDateString('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
}

export function formatDateTime(date: Date): string;
export function formatDateTime(date: Date | null | undefined): string | undefined;
export function formatDateTime(date: Date | null | undefined): string | undefined {
  if (!date) return undefined;
  return new Date(date).toLocaleString('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function areDatesTheSameDay(date1: Date, date2: Date): boolean {
  return (
    date1.getFullYear() === date2.getFullYear() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getDate() === date2.getDate()
  );
}
